import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { AuthService } from './authService.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Permissions } from './permission.service';
import { UserToken } from './userToken.service';
import { GlobalState } from '../../../global.state';
import { MasterRepo } from '../../repositories/index';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { MessageDialog } from '../../../pages/modaldialogs/messageDialog/messageDialog.component';

@Injectable()
export class CanActivateTeam implements CanActivate {
  viewPermission: Array<string> = [];
  user: any;
  constructor(
    private permission: Permissions,
    private userToken: UserToken,
    private gblstate: GlobalState,
    private _authService: AuthService,
    private masterService: MasterRepo,
    private router: Router,
    public dialog: MatDialog
  ) {
    this.viewPermission = gblstate.getGlobalSetting('View-Permission') || [];
    console.log({ views: this.viewPermission });
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // return true;
    var messageSubject: BehaviorSubject<string> = new BehaviorSubject<string>(
      ''
    );
    var message$: Observable<string> = messageSubject.asObservable();
    var LoggedIn = this._authService.getAuth();
    console.log({ LoggedIn: LoggedIn.profile.UserId }, 'loggigiggi');
    this.user = LoggedIn;
    console.log(LoggedIn.profile.UserId, 'var loggedIn');
    console.log('userrrrrr', this.user);
    if (!(LoggedIn && LoggedIn.profile)) {
      //this.router.navigate(['login']);

      messageSubject.next(
        'Guard.service.ts:You are not logged In . Please login in'
      );
      var dialogref = this.dialog.open(MessageDialog, {
        hasBackdrop: true,
        data: { header: 'Information', message: message$ },
      });
      setTimeout(() => {
        dialogref.close();
      }, 2000);
      return false;
    } else {
      var sub = this.masterService.checkUserValid().subscribe((res: any) => {
        if (res == false) {
          console.log({ checkLogin1: false });
          messageSubject.next('Invalid User');
          var dialogref = this.dialog.open(MessageDialog, {
            hasBackdrop: true,
            data: { header: 'Information', message: message$ },
          });
          setTimeout(() => {
            dialogref.close();
            return false;
          }, 2000);
          return false;
        }
        return false;
      });
    }
    console.log({ route: route.params.length });
    console.log('check  ' + this._authService.canActive);
    console.log({ activatedsnapshot: route });
    console.log({ routerstate: state });
    //console.log({ routepath: route.routeConfig.path });
    // console.log({ checkMenuRight: this._authService.checkMenuRight(route.url[0].path, route.params["mode"]) });
    // let viewToOpen = route.routeConfig.path;
    // console.log(this.viewPermission.find((x) => x.toUpperCase() === viewToOpen.toUpperCase()));
    // var path:string;
    var path: string = route.url[0].path;

    // if(route.params[]) {}
    // if (route.params["vt"] != null && route.params["vt"] == 18) {
    //   path = "incomevoucher";
    // } else if (route.params["vt"] != null && route.params["vt"] == 17) {
    //   path = "expensesvoucher";
    // } else if (route.params["vt"] != null && route.params["vt"] == 15) {
    //   path = "creditnote";
    // } else if (route.params["vt"] != null && route.params["vt"] == 16) {
    //   path = "debitnote";
    // } else if (route.params["pf"] != null && route.params["pf"] == "DN") {
    //   path = "debitnoteitembase";
    // } else if (route.params["pf"] != null && route.params["pf"] == "CN") {
    //   path = "creditnoteitembase";
    // } else {
    //   path = route.url[0].path
    // }

    // path = route.url[0].path;
    var right: string = route.params['mode'];
    console.log({ right: right });
    if (right == undefined) right = 'list';
    console.log({ path: path, right: right });
    var result = this._authService.getMenuRight(path, right);
    console.log({ checkmenuright: result });
    if (!path) {
      console.log({ ifPathfalse: path, list: result.list });
      if (result.list == true) {
        return true;
      }
    } else {
      console.log({ ifPathtrue: path, right: right });
      if (result.right == true) {
        return true;
      } else {
        if (right == 'list') {
          if (result.list == true) {
            return true;
          }
        }
      }
    }
    messageSubject.next('You are not authorize for this operation');
    var dialogref = this.dialog.open(MessageDialog, {
      hasBackdrop: true,
      data: { header: 'Information', message: message$ },
    });
    setTimeout(() => {
      dialogref.close();
      return false;
    }, 2000);
    return false;
    //   if (this._authService.checkMenuRight(path, route.params["mode"]) == true && route.url[0] != null && route.url[1] != null) {
    //     // if (this.viewPermission.find((x) => x.toUpperCase() == viewToOpen.toUpperCase())) {
    //     //   console.log("permission-true1");

    //      console.log("permission-false1");
    //      return true;
    //   }

    // if(this._authService.checkMenuRight(path, route.params["mode"]) == false && route.url[0] != null && route.url[1] == null) {
    //   // if (this.viewPermission.find((x) => x.toUpperCase() == viewToOpen.toUpperCase())) {
    //   //   console.log("permission-true2");
    //   //   return true;
    //   // }

    //   console.log("permission-false2");
    //   return true;
    // }
  }
}

/*
@NgModule({
  imports: [
    RouterModule.forRoot([
      {
        path: 'team/:id',
        component: TeamCmp,
        canActivate: [CanActivateTeam]
      }
    ])
  ],
  providers: [CanActivateTeam, UserToken, Permissions]
})
class AppModule {}

*/
